import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { TranslationService } from "src/app/translation.service";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";

import { DataService } from "./../../data.service";
import { GUID } from "./../../guid";
import { AppConfig } from "./../../config";
import { MatDialog } from "@angular/material";
import { getRequestID } from "src/app/requestid";
import { eventId } from "src/app/eventid";

@Component({
  selector: "app-metaobjectnew",
  templateUrl: "./metaobjectnew.component.html",
  styleUrls: ["./metaobjectnew.component.scss"]
})
export class MetaobjectNewComponent implements OnInit {
  @ViewChild("translateDialog", { static: false })
  translateDialog!: TemplateRef<any>;
  nodeMapping: any;
  metaobject: any;
  applicationId: string;
  isLoading = false;
  isError = false;
  errorMessage = "";
  objectName = "";
  mode = "New";
  metaobjectId = "";
  // id = "";
  languages: Array<any>;
  translatedLabels = [];
  data: any;
  dialogRef: any;

  objectAttributesDefnArr: any[];
  objectAttributeArray = [];
  guid: GUID;
  objectTypeSelect = [
    { value: "Domain", label: "Domain" },
    { value: "Admin", label: "Admin" },
    { value: "Meta", label: "Meta" }
  ];

  categorySelect = [
    { value: "Type A", label: "Type A" },
    { value: "Type B", label: "Type B" },
    { value: "Type C", label: "Type C" },
    { value: "Type D", label: "Type D" }
  ];

  ClassificationSelect = [
    { value: "PUBLIC", label: "Public" },
    { value: "INTERNAL", label: "Internal" },
    { value: "PII", label: "PII" },
    { value: "REGULATED_PII", label: "Regulated PII" },
    { value: "FINANCIAL", label: "Financial" },
    { value: "CREDENTIAL", label: "Credential" },
    { value: "SECRET", label: "Secret" }
  ];
  redactionDefaultSelect = [
    { value: "NONE", label: "None" },
    { value: "FULL", label: "Full" },
    { value: "PARTIAL", label: "Partial" },
    { value: "HASH", label: "Hash" },
    { value: "REMOVE", label: "Remove" },
    { value: "TOKENIZE", label: "Tokenize" }
  ];
  auditModeSelect = [
    { value: "NONE", label: "None" },
    { value: "BASIC", label: "Basic" },
    { value: "METADATA", label: "Metadata" },
    { value: "FULL", label: "Full" },
    { value: "FORENSIC", label: "Forensic" }
  ];
  auditOutcomeSelect = [
    { value: "SUCCESS_ONLY", label: "Success Only" },
    { value: "FAILURE_ONLY", label: "Failure Only" },
    { value: "BOTH", label: "Both" }
  ];

  parentObjects: Array<any>;

  detailForm = this.fb.group({
    label: "",
    name: new FormControl({ value: "", disabled: true }, Validators.required),
    pluralname: "",
    node: "",
    code: new FormControl({ value: "", disabled: true }, Validators.required),
    objecttype: "",
    category: "",
    description: "",
    standard: false,
    parentobjectid: "",
    parentobjectname: "",
    parentobject: "",
    embeddedobject: false,
    virtualobject: false,
    active: true,
    allowreports: false,
    allowactivities: false,
    trackfieldhistory: false,
    allowsearch: false,
    enablelicensing: false,
    allowworkflow: false,
    notesandattachments: false,
    allowqueuepublishing: false,
    alloweventpublish: false,
    mastertype: false,
    childtype: false,
    fieldvalidation: false,
    pathsetting: false,
    process: false,
    team: false,
    followup: false,
    linkobject: false,
    iconname: "",
    classification: "",
    redactiondefault: "",
    sortorder: 0,
    sinceversionseq: 0,
    deprecatedversionseq: 0,
    auditmode: "",
    auditoutcome: "",
    licensable: false,
    auditable: false,
    system: false
  });

  attributeForm: FormGroup;
  attributeitems: FormArray;

  createItem(a: any, t: any, v: any, p = "", l: any, h: any): FormGroup {
    return this.fb.group({
      attr: a,
      type: t,
      value: v,
      placeholder: p,
      label: l,
      hint: h
    });
  }

  addAttributeItem(
    a: any,
    t: any,
    v: string | boolean,
    p = "",
    l: any,
    h: any
  ): void {
    this.attributeitems = this.attributeForm.get("attributeitems") as FormArray;
    this.attributeitems.push(this.createItem(a, t, v, p, l, h));
  }

  removeSpacesFromName() {
    const control = this.detailForm.get("name");
    if (control && control.value) {
      control.setValue(control.value.replace(/\s+/g, ""), { emitEvent: false });
    }
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private dataService: DataService,
    private toastrService: ToastService,
    private appConfig: AppConfig,
    private translationService: TranslationService,
    public dialog: MatDialog
  ) {}
  translateForm: FormGroup;

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.metaobjectId = this.route.snapshot.params.id;
      this.objectName = this.route.snapshot.params.objectname;
    });

    // this.applicationId = this.appConfig.defaultapplicationid;
    // this.applicationId = this.appConfig.defaultapplicationid;
    this.applicationId = localStorage.getItem("crm_metaapplicationid");
    this.guid = new GUID();

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.detailForm.controls.name.enable();
      this.detailForm.controls.code.enable();
    } else if (this.mode.toLowerCase() == "edit") {
      this.detailForm.controls.name.disable();
      this.detailForm.controls.code.disable();
    }

    //load parent objects
    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);

      //this.detailForm.controls.parentobject.patchValue('');

      if (this.mode.toLowerCase() == "edit") {
        // this.getMetaobjectById();
      }
    });

    this.attributeForm = this.fb.group({
      objectid: "",
      name: "",
      attributeitems: this.fb.array([])
    });

    // this.guid = new GUID();

    // console.log("mode", this.mode);

    //load button attributes definition
    this.objectAttributesDefnArr = this.appConfig.objectAttributes;
    console.log(" this.objectAttributesDefnArr", this.objectAttributesDefnArr);

    // //create button type picklist from buttontypes
    // for (let i = 0; i < this.appConfig.buttonTypes.length; i++) {
    //   //convert to titecase
    //   var strLabel = this.appConfig.buttonTypes[i];
    //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
    //   this.buttonTypeSelect.push({
    //     value: this.appConfig.buttonTypes[i],
    //     label: strLabel,
    //   });
    // }

    // //create button action type picklist from buttonactiontypes
    // for (let i = 0; i < this.appConfig.buttonActionTypes.length; i++) {
    //   //convert to titecase
    //   var strLabel = this.appConfig.buttonActionTypes[i];
    //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
    //   this.buttonActionTypeSelect.push({
    //     value: this.appConfig.buttonActionTypes[i],
    //     label: strLabel,
    //   });
    // }

    // //create display list from displaytypes
    // for (let i = 0; i < this.appConfig.buttonDisplayTypes.length; i++) {
    //   //convert to titecase
    //   var strLabel = this.appConfig.buttonDisplayTypes[i];
    //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
    //   this.displayTypeSelect.push({
    //     value: this.appConfig.buttonDisplayTypes[i],
    //     label: strLabel,
    //   });
    // }

    // //create behaviour list from behaviourtypes
    // for (let i = 0; i < this.appConfig.buttonBehaviourTypes.length; i++) {
    //   //convert to titecase
    //   var strLabel = this.appConfig.buttonBehaviourTypes[i];
    //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
    //   this.behaviourTypeSelect.push({
    //     value: this.appConfig.buttonBehaviourTypes[i],
    //     label: strLabel,
    //   });
    // }

    if (this.mode.toLowerCase() == "new") {
      //assign default button type, action type
      // this.detailForm.controls["buttontype"].setValue("Common");
      // this.detailForm.controls["actiontype"].setValue("CustomView");
      this.loadAttributes();
    } else if (this.mode.toLowerCase() == "edit") {
      // this.getMetabuttonById();
      this.getMetaobjectById();
    }

    this.translateForm = this.fb.group({
      translate: this.fb.array([]),
      code: "",
      language: ""
    });

    // Initialize with one language by default

    if (this.mode.toLowerCase() == "edit") {
      this.addLang();
      this.getLanguage();
      this.getTranslationLabelById();
    }
  }

  getLanguage() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );
    const subdomain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.subdomain`
    );

    this.isLoading = true;
    this.dataService
      .getOrgLanguage(organizationid, domain, subdomain)
      .subscribe(
        (res) => {
          // alert('****res****' + JSON.stringify(res));
          console.log(res);
          if (res !== null && res.success == 1) {
            var allLanguages = res.data.orglanguage;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < allLanguages.length; i++) {
              objArr.push({
                value: allLanguages[i].code,
                label: allLanguages[i].language
              });
            }
            this.languages = objArr;

            this.isLoading = false;
          } else {
            console.log("error while retrieving");
            this.isLoading = false;
            this.showError(res.message);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          this.showError(err.message);
        }
      );
  }

  selectedLanguageChange(event: { value: string; label: any }) {
    console.log("selectedLanguageChange", event);
    if (event.value.trim() != "") {
      this.translateForm.controls["code"].setValue(event.value);
      this.translateForm.controls["language"].setValue(event.label);
    } else {
      this.translateForm.controls["code"].setValue("");
      this.translateForm.controls["language"].setValue("");
    }
  }
  // languages: string[] = ["English", "es", "French", "German"];
  // selectedLanguage: string = "es";
  translatedText: string = "";

  // translateForm = new FormGroup({
  //   translate: new FormArray([
  //     new FormGroup({
  //       selectedLanguage: new FormControl(""),
  //       translatedText: new FormControl(""),
  //       // number: new FormControl(''),
  //       // email: new FormControl('')
  //     }),
  //   ]),

  // });

  translatingDialog(labelname: any): void {
    console.log("labelname", labelname);

    if (!labelname) {
      return;
    }

    this.translateForm.patchValue({ label: labelname });
    this.data = {
      labelname: labelname
    };

    this.dialogRef = this.dialog.open(this.translateDialog, {
      data: this.data,
      height: "400px",
      width: "800px"
    });

    this.dialogRef.afterClosed().subscribe((result: any) => {
      console.log("The dialog was closed.");
      if (result) {
      }
    });
  }

  get translate(): FormArray {
    return this.translateForm.get("translate") as FormArray;
  }

  addLang() {
    const translateGroup = this.fb.group({
      languageCode: ["", Validators.required],
      translatedName: ["", Validators.required]
    });

    this.translate.push(translateGroup);
  }

  // translator() {
  //   const selectedLanguage =
  //     this.translateForm.value.translate[0].selectedLanguage;
  //   const labelname = this.data.labelname;
  //   console.log(selectedLanguage);
  //   console.log(this.translateForm.value.translate);
  //   this.translationService
  //     .translate(labelname, selectedLanguage)
  //     .subscribe((response: any) => {
  //       this.translatedText = response.data.translations[0].translatedText;
  //     });
  // }
  translator(index: number) {
    const translateGroup = this.translate.at(index) as FormGroup;
    const selectedLanguage = translateGroup.get("languageCode").value;
    const labelname = this.data.labelname;

    console.log(selectedLanguage);

    this.translationService
      .translate(labelname, selectedLanguage, "en")
      .subscribe((response: any) => {
        const translatedText = response.data.translations[0].translatedText;
        translateGroup.get("translatedName").setValue(translatedText);
      });
  }
  saveTranslated() {
    // console.log(this.translateForm);
    if (this.translateForm.valid) {
      // Handle the form submission
      console.log("Saving form data:", this.translateForm.value.translate);

      this.translatedLabels = this.translateForm.value.translate;
    }
    this.dialogRef.close();
  }
  removeLang(index: number) {
    this.translate.removeAt(index);
  }

  close() {
    this.dialogRef.close();
  }
  getTranslationLabelById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metaobjectlabeltranslation: {
          metaobjectid: this.metaobjectId
        }
      }
    };

    this.isLoading = true;
    this.dataService.getObjectTranslationLabelById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // Loop through the response and add translation fields
          if (res.data.metaobjectlabeltranslation) {
            this.translate.clear();
            res.data.metaobjectlabeltranslation.forEach((translation) => {
              const translateGroup = this.fb.group({
                languageCode: [translation.languagecode, Validators.required],
                translatedName: [
                  translation.translatedlabel,
                  Validators.required
                ]
              });
              this.translate.push(translateGroup);
            });
            // After populating translateForm, update translatedLabels
            this.translatedLabels = res.data.metaobjectlabeltranslation.map(
              (translation) => ({
                languageCode: translation.languagecode,
                translatedName: translation.translatedlabel
              })
            );

            console.log(this.translatedLabels);
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Metaobject Error!", options);
  }

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark"
    };
    this.toastrService.warning(data, "", options);
  }

  loadAttributes() {
    this.objectAttributeArray = this.objectAttributesDefnArr;
    if (this.attributeitems != undefined) this.attributeitems.clear();

    //create new formarry for button attributes
    var fgArray = new Array<FormGroup>();
    //transform json to attribute form controls
    for (let i = 0; i < this.objectAttributeArray.length; i++) {
      var item = this.objectAttributeArray[i];
      console.log(item);

      // Enable DuplicateDetection and DuplicateMatch by default
      if (
        item.attr.toLowerCase() === "duplicatedetection" ||
        item.attr.toLowerCase() === "duplicatematch"
      ) {
        this.addAttributeItem(
          item.attr,
          item.type,
          true,
          "",
          item.label,
          item.hint
        );

        continue;
      }

      // Check if item is 'recordsharing'
      if (item.attr.toLowerCase() == "recordsharing") {
        // Set default value for boolean to true and disable
        if (this.mode.toLocaleLowerCase() == "new") {
          this.addAttributeItem(
            item.attr,
            item.type,
            true,
            "",
            item.label,
            item.hint
          ); // true for disabled
        } else if (this.mode.toLocaleLowerCase() == "edit") {
          var value = this.metaobject.attributes[item.attr];
          if (value instanceof Array) {
            value = JSON.stringify(value);
          }
          this.addAttributeItem(
            item.attr,
            item.type,
            value,
            "",
            item.label,
            item.hint
          ); // true for disabled
        }
        continue; // Skip the rest of the loop for this attribute
      }

      if (this.mode.toLocaleLowerCase() == "new") {
        if (item.type.toLocaleLowerCase() == "boolean") {
          this.addAttributeItem(
            item.attr,
            item.type,
            false,
            "",
            item.label,
            item.hint
          );
        } else if (item.type.toLocaleLowerCase() == "json") {
          this.addAttributeItem(
            item.attr,
            item.type,
            "{}",
            "",
            item.label,
            item.hint
          );
        } else {
          this.addAttributeItem(
            item.attr,
            item.type,
            "",
            "",
            item.label,
            item.hint
          );
        }
      } else if (this.mode.toLocaleLowerCase() == "edit") {
        //get value from the attributes
        var value = this.metaobject.attributes[item.attr];
        if (value instanceof Array) {
          value = JSON.stringify(value);
        }
        this.addAttributeItem(
          item.attr,
          item.type,
          value,
          "",
          item.label,
          item.hint
        );
      }
    }

    console.log(this.attributeForm.value);
  }

  // isRecordSharingDisabled(item: any): boolean {
  //   // Ensure item.controls and item.controls.attr are valid before checking
  //   const attrValue =
  //     item.controls && item.controls.attr ? item.controls.attr.value : null;

  //   // Ensure detailForm['name'] is valid before checking
  //   const nameValue =
  //     this.detailForm && this.detailForm.get("name")
  //       ? this.detailForm.get("name").value
  //       : null;

  //   // If attr is 'recordsharing' and name includes 'history', enable the checkbox
  //   if (attrValue && attrValue.toLowerCase() === "recordsharing") {
  //     // return !nameValue || !nameValue.toLowerCase().includes('history');
  //     return !(
  //       nameValue &&
  //       (nameValue.toLowerCase().includes("history") ||
  //         nameValue.toLowerCase().includes("changelog"))
  //     );
  //   }

  //   // Disable for other attributes
  //   return false;
  // }
  isRecordSharingDisabled(item: any): boolean {
    const attrValue =
      item.controls && item.controls.attr ? item.controls.attr.value : null;

    const nameValue =
      this.detailForm && this.detailForm.get("name")
        ? this.detailForm.get("name").value
        : null;

    if (attrValue && attrValue.toLowerCase() === "recordsharing") {
      // Edit mode + DuplicateDetection / DuplicateMatch
      // => recordsharing ENABLED
      if (
        this.mode.toLowerCase() === "edit" &&
        this.objectName &&
        (this.objectName.toLowerCase() === "duplicatedetection" ||
          this.objectName.toLowerCase() === "duplicatematch")
      ) {
        return false;
      }

      // Existing History / ChangeLog behavior
      return !(
        nameValue &&
        (nameValue.toLowerCase().includes("history") ||
          nameValue.toLowerCase().includes("changelog"))
      );
    }

    return false;
  }

  metaobjectList() {
    this.router.navigateByUrl("home/metaobjectlist");
  }

  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.detailForm.controls["parentobjectid"].setValue(event.value);
      this.detailForm.controls["parentobjectname"].setValue(event.label);
    } else {
      this.detailForm.controls["parentobjectid"].setValue("");
      this.detailForm.controls["parentobjectname"].setValue("");
    }
  }
  getMetaobjectById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        metaobject: {
          id: this.metaobjectId
        }
      }
    };
    console.log(postOption);

    this.isLoading = true;
    this.dataService.getMetaobjectById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.metaobject = res.data.metaobject;
          console.log(this.metaobject);
          // this.nodeMapping = JSON.stringify(this.metaobject.nodemapping);
          this.nodeMapping = Object.keys(this.metaobject.nodemapping).join(",");
          console.log(this.nodeMapping);
          if (this.metaobject != null) {
            this.applicationId = this.metaobject.metaapplicationid;

            this.detailForm.controls["label"].setValue(this.metaobject.label);
            this.detailForm.controls["name"].setValue(this.metaobject.name);
            this.detailForm.controls["pluralname"].setValue(
              this.metaobject.pluralname
            );
            this.detailForm.controls["code"].setValue(this.metaobject.code);
            this.detailForm.controls["objecttype"].setValue(
              this.metaobject.objecttype
            );
            this.detailForm.controls["category"].setValue(
              this.metaobject.category
            );
            this.detailForm.controls["description"].setValue(
              this.metaobject.description
            );
            this.detailForm.controls["standard"].setValue(
              this.metaobject.standard
            );
            this.detailForm.controls["parentobjectid"].setValue(
              this.metaobject.parentobjectid
            );
            this.detailForm.controls["parentobjectname"].setValue(
              this.metaobject.parentobjectname
            );
            this.detailForm.controls["node"].setValue(this.nodeMapping);

            //assign right parentobject
            this.detailForm.controls.parentobject.patchValue(
              this.metaobject.parentobjectid
            );

            this.detailForm.controls["embeddedobject"].setValue(
              this.metaobject.embeddedobject
            );
            this.detailForm.controls["virtualobject"].setValue(
              this.metaobject.virtualobject
            );
            this.detailForm.controls["active"].setValue(this.metaobject.active);
            this.detailForm.controls["allowreports"].setValue(
              this.metaobject.allowreports
            );
            this.detailForm.controls["allowactivities"].setValue(
              this.metaobject.allowactivities
            );
            this.detailForm.controls["trackfieldhistory"].setValue(
              this.metaobject.trackfieldhistory
            );
            this.detailForm.controls["allowsearch"].setValue(
              this.metaobject.allowsearch
            );
            this.detailForm.controls["enablelicensing"].setValue(
              this.metaobject.enablelicensing
            );
            this.detailForm.controls["allowworkflow"].setValue(
              this.metaobject.allowworkflow
            );
            this.detailForm.controls["notesandattachments"].setValue(
              this.metaobject.notesandattachments
            );
            this.detailForm.controls["allowqueuepublishing"].setValue(
              this.metaobject.allowqueuepublishing
            );
            this.detailForm.controls["alloweventpublish"].setValue(
              this.metaobject.alloweventpublish
            );
            this.detailForm.controls["mastertype"].setValue(
              this.metaobject.mastertype
            );
            this.detailForm.controls["childtype"].setValue(
              this.metaobject.childtype
            );
            this.detailForm.controls["fieldvalidation"].setValue(
              this.metaobject.fieldvalidation
            );
            this.detailForm.controls["pathsetting"].setValue(
              this.metaobject.pathsetting
            );
            this.detailForm.controls["process"].setValue(
              this.metaobject.process
            );
            this.detailForm.controls["team"].setValue(this.metaobject.team);

            this.detailForm.controls["followup"].setValue(
              this.metaobject.followup
            );
            this.detailForm.controls["linkobject"].setValue(
              this.metaobject.linkobject
            );

            this.detailForm.controls["iconname"].setValue(
              this.metaobject.iconname
            );

            this.detailForm.controls["classification"].setValue(
              this.metaobject.classification
            );
            this.detailForm.controls["redactiondefault"].setValue(
              this.metaobject.redactiondefault
            );

            this.detailForm.controls["sortorder"].setValue(
              Number(this.metaobject.sortorder || 0)
            );

            this.detailForm.controls["sinceversionseq"].setValue(
              Number(
                this.metaobject.sinceversionseq != null
                  ? this.metaobject.sinceversionseq
                  : 0
              )
            );

            this.detailForm.controls["deprecatedversionseq"].setValue(
              Number(
                this.metaobject.deprecatedversionseq != null
                  ? this.metaobject.deprecatedversionseq
                  : 0
              )
            );

            this.detailForm.controls["auditmode"].setValue(
              this.metaobject.auditmode
            );
            this.detailForm.controls["auditoutcome"].setValue(
              this.metaobject.auditoutcome
            );

            this.detailForm.controls["licensable"].setValue(
              this.metaobject.licensable
            );
            this.detailForm.controls["auditable"].setValue(
              this.metaobject.auditable
            );
            this.detailForm.controls["system"].setValue(this.metaobject.system);

            this.objectAttributeArray = this.objectAttributesDefnArr;
            console.log("attributes", this.metaobject.attributes);

            var fgArray = new Array<FormGroup>();
            //transform json to attribute form controls
            for (let i = 0; i < this.objectAttributeArray.length; i++) {
              var item = this.objectAttributeArray[i];

              //get value from the attributes
              var value = this.metaobject.attributes[item.attr];
              if (value instanceof Array) {
                value = JSON.stringify(value);
              }
              // this.addAttributeItem(item.attr, item.type, value);
              // this.addAttributeItem(item.attr, item.type, "", "", item.label);
              if (item.type.toLocaleLowerCase() == "json") {
                this.addAttributeItem(
                  item.attr,
                  item.type,
                  JSON.stringify(value) || "{}",
                  "",
                  item.label,
                  item.hint
                );
              } else {
                this.addAttributeItem(
                  item.attr,
                  item.type,
                  value,
                  "",
                  item.label,
                  item.hint
                );
              }
            }

            console.log("detailForm", this.detailForm);
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        data: {
          metaobject: {
            objecttype: "Domain"
          }
        }
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name
              });
            }
            this.parentObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  save() {
    this.isLoading = false;
    this.isError = false;
    console.log("save");
    // TEAM INFO VALIDATION
    const isTeamEnabled = this.detailForm.controls["team"].value;

    if (isTeamEnabled) {
      const attrs = this.attributeForm.get("attributeitems").value;

      const teamInfoAttr = attrs.find((a) => a.attr === "teaminfo");

      let value = teamInfoAttr ? teamInfoAttr.value : null;

      try {
        // If value is a JSON string like "{}" or "[]", parse it
        if (typeof value === "string") {
          value = JSON.parse(value);
        }
      } catch (e) {
        // invalid JSON = empty
        value = null;
      }

      // check empty
      const isEmpty =
        !value ||
        value === "" ||
        (typeof value === "object" && Object.keys(value).length === 0);

      if (isEmpty) {
        this.showWarning("Team Info is mandatory when Team is enabled");
        return;
      }
    }

    if (this.detailForm.controls["label"].value.toString().trim() == "") {
      this.showWarning("Metaobject label is mandatory");
      return;
    }
    if (this.detailForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Metaobject name is mandatory");
      return;
    }
    if (this.detailForm.controls["pluralname"].value.toString().trim() == "") {
      this.showWarning("Metaobject plural label is mandatory");
      return;
    }
    if (this.detailForm.controls["code"].value.toString().trim() == "") {
      this.showWarning("Metaobject code is mandatory");
      return;
    }
    if (this.detailForm.controls["objecttype"].value.toString().trim() == "") {
      this.showWarning("Metaobject object type is mandatory");
      return;
    }
    if (this.detailForm.controls["category"].value.toString().trim() == "") {
      this.showWarning("Metaobject category is mandatory");
      return;
    }

    var metaobjectLabel = this.detailForm.controls["label"].value.trim();
    // metaobjectLabel = metaobjectLabel.replace(/\w\S*/g, function (txt: any) {
    //   return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    // });

    var metaobjectName = this.detailForm.controls["name"].value.trim();
    // metaobjectName = metaobjectName.replace(/\w\S*/g, function(txt:any){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
    // metaobjectName = metaobjectName.replace(/ /g, "");

    var metaobjectPlural = this.detailForm.controls["pluralname"].value.trim();
    metaobjectPlural = metaobjectPlural.replace(
      /\w\S*/g,
      function (txt: string) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      }
    );

    //     var nodeMapping = this.detailForm.controls['node'].value;
    //     nodeMapping = nodeMapping.replace(/,/g, "\n")
    // var node=[];
    //     // var nodemap={};
    //     var arr = nodeMapping.split("\n");
    //     for (let i = 0; i < arr.length; i++) {
    //       if(arr[i].trim() != ''){
    //       var  nodemap=({
    //           // [nodeMapping]: arr[i]
    //           [arr[i]]:metaobjectName
    //         });
    //       }
    //       node.push(nodemap)

    //       console.log("node****",node)

    //       console.log("nodemap****",nodemap)

    var nodeMapping = this.detailForm.controls["node"].value;
    console.log(nodeMapping);
    nodeMapping = nodeMapping.replace(/,/g, "\n");
    var node = {};
    var arr = nodeMapping.split("\n");

    for (let i = 0; i < arr.length; i++) {
      if (arr[i].trim() != "") {
        node[arr[i]] = metaobjectName;
      }
    }

    console.log(node);

    console.log("mode", this.mode);
    if (this.mode.toLowerCase() == "new") {
      this.metaobjectId = this.guid.getGUID("metaobject");
      console.log("metaobjectid", this.metaobjectId);
    }

    console.log("preparing data***");
    var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

    //prepare data for saving: application
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      useralias: localStorage.getItem("crm_useralias"),
      profileid: userDetail.profileid,
      profilename: userDetail.profilename,
      data: {
        metaobject: {
          metaapplicationid: this.applicationId,
          mode: this.mode,
          id: this.metaobjectId,
          label: metaobjectLabel,
          name: metaobjectName,
          pluralname: metaobjectPlural,
          code: this.detailForm.controls["code"].value.trim(),
          objecttype: this.detailForm.controls["objecttype"].value.trim(),
          category: this.detailForm.controls["category"].value.trim(),
          description: this.detailForm.controls["description"].value.trim(),
          standard: true,
          parentobjectid:
            this.detailForm.controls["parentobjectid"].value.trim(),
          parentobjectname:
            this.detailForm.controls["parentobjectname"].value.trim(),
          embeddedobject: this.detailForm.controls["embeddedobject"].value,
          virtualobject: this.detailForm.controls["virtualobject"].value,
          active: this.detailForm.controls["active"].value,
          allowreports: this.detailForm.controls["allowreports"].value,
          allowactivities: this.detailForm.controls["allowactivities"].value,
          trackfieldhistory:
            this.detailForm.controls["trackfieldhistory"].value,
          allowsearch: this.detailForm.controls["allowsearch"].value,
          enablelicensing: this.detailForm.controls["enablelicensing"].value,
          allowworkflow: this.detailForm.controls["allowworkflow"].value,
          notesandattachments:
            this.detailForm.controls["notesandattachments"].value,
          allowqueuepublishing:
            this.detailForm.controls["allowqueuepublishing"].value,
          alloweventpublish:
            this.detailForm.controls["alloweventpublish"].value,
          mastertype: this.detailForm.controls["mastertype"].value,
          childtype: this.detailForm.controls["childtype"].value,
          fieldvalidation: this.detailForm.controls["fieldvalidation"].value,
          pathsetting: this.detailForm.controls["pathsetting"].value,
          process: this.detailForm.controls["process"].value,
          team: this.detailForm.controls["team"].value,
          followup: this.detailForm.controls["followup"].value,
          linkobject: this.detailForm.controls["linkobject"].value,
          iconname: this.detailForm.controls["iconname"].value,

          // 🔥 ADD THIS
          classification: this.detailForm.controls["classification"].value,
          redactiondefault: this.detailForm.controls["redactiondefault"].value,
          sortorder: this.detailForm.controls["sortorder"].value,
          sinceversionseq:
            this.detailForm.controls["sinceversionseq"].value != null
              ? this.detailForm.controls["sinceversionseq"].value
              : 0,
          deprecatedversionseq:
            this.detailForm.controls["deprecatedversionseq"].value != null
              ? this.detailForm.controls["deprecatedversionseq"].value
              : 0,
          auditmode: this.detailForm.controls["auditmode"].value,
          auditoutcome: this.detailForm.controls["auditoutcome"].value,
          licensable: this.detailForm.controls["licensable"].value,
          auditable: this.detailForm.controls["auditable"].value,
          system: this.detailForm.controls["system"].value,

          nodemapping: node,
          attributes: {},
          objectlabeltranslation: []
        }
      }
    };

    //formulate object attributes and assign it to postoption
    //get formarray details
    var attrbs = {};

    var arrayControl = this.attributeForm.get("attributeitems") as FormArray;
    for (let c of arrayControl.controls) {
      console.log(c);
      attrbs[c.get("attr").value] = c.get("value").value;

      let attrKey = c.get("attr").value;
      let attrValue = c.get("value").value;

      if (c.value.type == "json") {
        // attrbs[attrKey] = JSON.parse(attrValue);
        try {
          attrbs[attrKey] = JSON.parse(attrValue);
        } catch (e) {
          // alert(`The value for attribute ${attrKey} is not a valid JSON.`);
          this.showWarning(
            `The value for attribute ${attrKey} is not a valid JSON.`
          );
          return;
        }
      }
    }

    //push attributes to request data (postoption)
    postOption.data.metaobject.attributes = attrbs;

    if (this.mode.toLocaleLowerCase() == "edit") {
      var arrtranslatedFields = [];
      for (let translatedfieldlabel of this.translatedLabels) {
        var objectlabelTranslation = {
          id: this.guid.getGUID("metaobjectlabeltranslation"),
          organizationid: localStorage.getItem("crm_orgid"),
          metaobjectid: this.metaobjectId,
          languagecode: translatedfieldlabel.languageCode,
          translatedlabel: translatedfieldlabel.translatedName,
          active: true
        };

        //push it to array
        arrtranslatedFields.push(objectlabelTranslation);
      }
      postOption.data.metaobject.objectlabeltranslation = arrtranslatedFields;
    }

    // let postoption2={
    //   // myObject[nodeMapping] = metaobjectName
    //   NodeMapping:node
    // }

    console.log("postOption", postOption);
    // console.log("Postoption222",postoption2)

    this.isLoading = true;

    // this.dataService.upsertNode(postoption2).subscribe(
    //   res => {
    //     //alert('****res****' + JSON.stringify(res));
    //     console.log(res);
    //     if(res.success == 1){
    //       this.showSuccess(res.message);
    //       this.isLoading = false;
    //       this.router.navigateByUrl('/home/applicationdetail/'+ this.applicationId + '/' + this.detailForm.controls['name'].value.trim());
    //     }
    //     else{
    //       console.log("error");
    //       this.showError(res.message);
    //       this.isLoading = false;
    //     }
    //   },
    //   err =>{
    //     console.log("Error***:",err);
    //     this.showError(err.message);
    //     this.isError = true;
    //     this.isLoading = false;
    //   }
    // )

    //
    const domain = localStorage.getItem(
      `${localStorage.getItem("crm_orgid")}.domain`
    );

    let publish = {
      // topic: "scherp.admin.basicaccesspermission.created",
      topic: `${domain}.admin.basicaccesspermission.created`, // ✅ dynamic
      group_id: "create_basicaccesspermission",
      message: [
        {
          context: {
            organizationid: localStorage.getItem("crm_orgid")
          },
          user: {
            org_code: localStorage.getItem(
              `${localStorage.getItem("crm_orgid")}.subdomain`
            ),
            app_name: domain
          },

          domain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.domain`
          ),
          subdomain: localStorage.getItem(
            `${localStorage.getItem("crm_orgid")}.subdomain`
          ),

          action: {
            modulename: metaobjectName
          }
        }
      ],
      relative_url: "api/v1/turbo/c/metaobject"
    };

    const orgId = localStorage.getItem("crm_orgid");

    const event_id = eventId("Metadata", this.objectName, "create");
    const requestid = getRequestID();
    const subdomain = localStorage.getItem(`${orgId}.subdomain`);
    // let publish = {
    //   topic: `${domain}.admin.basicaccesspermission.created`,
    //   group_id: "create_basicaccesspermission",

    //   message: [
    //     {
    //       current_context: {},

    //       context: {
    //         organizationid: orgId
    //       },

    //       user: {
    //         user_name: localStorage.getItem("crm_loginid"),

    //         _id: localStorage.getItem("crm_userid"),

    //         name: localStorage.getItem("crm_username"),

    //         app_name: domain
    //       },

    //       domain: domain,

    //       subdomain: subdomain,

    //       action: {
    //         modulename: this.objectName,
    //         event_id: event_id
    //       },

    //       // relative_url: "api/v1/turbo/c/metaobject",

    //       query: {}
    //     }
    //   ],
    //   relative_url: "api/v1/turbo/c/metaobject",

    //   request_id: requestid
    // };
    console.log("publish", publish);

    this.dataService.upsertMetaobject(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.showSuccess(res.message);
          this.isLoading = false;
          this.router.navigateByUrl(
            "/home/metaobjectdetail/" +
              this.metaobjectId +
              "/" +
              this.detailForm.controls["name"].value.trim()
          );

          if (this.mode.toLocaleLowerCase() == "new") {
            this.dataService.outboxeventPublish(publish).subscribe();
          }
        } else {
          console.log("error while savin");
          this.showError(res.message);
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.showError(err.message);
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
